import loadStyle from "@/styles/loadspinner.module.scss";

export const ImageLoader = () => {
	return <div className={loadStyle.loadSpinner}></div>;
};
